import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ROUTES } from '../../constants/routes.js';
import useE2eCommsBanner from '../../hooks/useE2eCommsBanner';
import '../../../styles/e2e/e2e-comms.scss';

// Lazy loading works with the bundles; loads only the new chunk. There is a flash in the UI though.
const AddHomeCountry = React.lazy(() => import('../AddHomeCountry/AddHomeCountry'));
const AddMobilePhone = React.lazy(() => import('../AddMobilePhone/AddMobilePhone'));
const SignIn = React.lazy(() => import('../SignIn/SignIn'));
const Autologin = React.lazy(() => import('../Autologin/Autologin'));
const CreateAccount = React.lazy(() => import('../CreateAccount/CreateAccount'));
const ResetPassword = React.lazy(() => import('../ResetPassword/ResetPassword'));
const ForgotUserNamePwd = React.lazy(() => import('../ForgotUserPwd/ForgotUserPwd'));
const Consents = React.lazy(() => import('../Consents/Consents'));
const SessionEnded = React.lazy(() => import('../SessionEnded/SessionEnded'));
const VerifyEmailEscrowExpired = React.lazy(() => import('../VerifyEmailEscrowExpired/VerifyEmailEscrowExpired'));
const VerifyMFARecaptcha = React.lazy(() => import('../VerifyMFARecaptcha/VerifyMFARecaptcha'));
const AuoWelcome = React.lazy(() => import('../AuoWelcome/AuoWelcome'));
const CreatePassword = React.lazy(() => import('../CreatePassword/CreatePassword'));
const VerifyMobilePhoneForgot = React.lazy(() => import('../VerifyMobilePhoneForForgot/VerifyMobilePhoneForForgot'));
const SecurityQuestions = React.lazy(() => import('../SecurityQuestions/SecurityQuestions'));
const VerifyMobilePhone = React.lazy(() => import('../VerifyMobilePhone/VerifyMobilePhone'));
const ResetPasswordLinks = React.lazy(() => import('../ResetPasswordLinks/ResetPasswordLinks'));
const ChooseAccountType = React.lazy(() => import('../ChooseAccountType/ChooseAccountType'));
const LinkAccounts = React.lazy(() => import('../LinkAccounts/LinkAccounts'));
const LinkAccountsError = React.lazy(() => import('../LinkAccountsError/LinkAccountsError'));
const LinkAccountsConfirmation = React.lazy(() => import('../LinkAccountConfirmation/LinkAccountConfirmation'));
const MFAOptions = React.lazy(() => import('../MFAOptions/MFAOptions'));
const SignInCode = React.lazy(() => import('../SignInCode/SignInCode'));
const VerifySignInCode = React.lazy(() => import('../VerifySignInCode/VerifySignInCode'));
const CodeOptions = React.lazy(() => import('../CodeOptions/CodeOptions'));
const CodeHelp = React.lazy(() => import('../CodeHelp/CodeHelp'));

function MainContent() {
  useE2eCommsBanner();

  return (
    <div className="main-page-content" role="main">
      <Routes>
        <Route path={ROUTES.AUTOLOGIN} element={<Autologin />} />
        <Route path={ROUTES.LOGIN_INTERNAL} element={<SignIn />} />
        <Route
          path={ROUTES.CREATE_ACCOUNT_LINK_ACCOUNTS_INTERNAL}
          element={<CreateAccount pageState="LinkAccount" />}
        />
        <Route path={ROUTES.CREATE_ACCOUNT_INTERNAL} element={<CreateAccount />} />
        <Route path={ROUTES.CONSENTS_INTERNAL} element={<Consents />} />
        <Route path={ROUTES.SESSION_ENDED_INTERNAL} element={<SessionEnded />} />
        <Route path={ROUTES.VERIFY_EMAIL_ESCROW_EXPIRED_INTERNAL} element={<VerifyEmailEscrowExpired />} />
        <Route path={ROUTES.RESET_PW_INTERNAL} element={<ResetPassword />} />
        <Route path={ROUTES.FORGOT_UN_PW_INTERNAL} element={<ForgotUserNamePwd />} />
        <Route path={ROUTES.UNVERIFIED_RECAPTCHA} element={<MFAOptions />} />
        <Route path={ROUTES.SOCIAL_LOGIN} element={<SignIn />} />
        <Route path={ROUTES.SOCIAL_LOGIN_CR} element={<CreateAccount />} />
        <Route path={ROUTES.AUO_WELCOME} element={<AuoWelcome />} />
        <Route path={ROUTES.CREATE_PW} element={<CreatePassword />} />
        <Route path={ROUTES.ADD_HOME_COUNTRY} element={<AddHomeCountry />} />
        <Route path={ROUTES.ADD_MOBILE_PHONE} element={<AddMobilePhone />} />
        <Route path={ROUTES.VERIFY_MOBILE_PHONE_FOR_FORGOT} element={<VerifyMobilePhoneForgot />} />
        <Route path={ROUTES.SECURITY_QUESTIONS} element={<SecurityQuestions />} />
        <Route path={ROUTES.VERIFY_MOBILE_PHONE} element={<VerifyMobilePhone />} />
        <Route path={ROUTES.VERIFY_MFA_RECAPTCHA} element={<VerifyMFARecaptcha />} />
        <Route path={ROUTES.RESET_PW_LINKS} element={<ResetPasswordLinks />} />
        <Route path={ROUTES.CHOOSE_ACCOUNT_TYPE_INTERNAL} element={<ChooseAccountType />} />
        <Route path={ROUTES.LINK_ACCOUNTS} element={<LinkAccounts />} />
        <Route path={ROUTES.LINK_ACCOUNTS_ERROR} element={<LinkAccountsError />} />
        <Route path={ROUTES.LINK_ACCOUNTS_CONFIRMATION} element={<LinkAccountsConfirmation />} />
        <Route path={ROUTES.SIGNIN_CODE} element={<SignInCode />} />
        <Route path={ROUTES.VERIFY_CODE} element={<VerifySignInCode />} />
        <Route path={ROUTES.CODE_OPTIONS} element={<CodeOptions />} />
        <Route path={ROUTES.CODE_HELP} element={<CodeHelp />} />
        <Route path="*" element={<SignIn />} />
      </Routes>
    </div>
  );
}

export default MainContent;
